/**-- external -- */
import React from "react";
import { EmptyState } from "@toddle-edu/ds-web";
import {
  AddClassIllustration,
  NoFilterResultIllustration,
} from "@toddle-edu/ds-theme";

/**-- internal -- */
import { useI18n } from "Hooks";

const EmptyPlaceholder = ({ searchText, isLearningCoursesFeed }) => {
  const isAnyFilterApplied = !!searchText;

  const { t } = useI18n(["common"]);

  return (
    <EmptyState
      illustration={
        isAnyFilterApplied ? NoFilterResultIllustration : AddClassIllustration
      }
      title={
        isAnyFilterApplied
          ? t("common:filter_result_msg", {
              label: isLearningCoursesFeed
                ? t("course:courses")
                : t("common:classes"),
            })
          : isLearningCoursesFeed
          ? t("course:no_courses_created")
          : t("common:no_class_found_plural")
      }
    />
  );
};

export default EmptyPlaceholder;
